import { createAction } from "@reduxjs/toolkit";

const createPayload =
    <T>() =>
    (payload: T) => ({ payload });

export const createActionWithPayload = <T>(type: string) => createAction(type, createPayload<T>());
